/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1Distribution } from '../models/V1Distribution';
import { HttpFile } from '../http/http';

/**
* Event emitted when distribution is created or updated on an order line.
*/
export class V1OrderLineDistributionSet {
    /**
    * ID of the Order Line.
    */
    'id'?: string;
    /**
    * ID of the organization.
    */
    'orgId'?: string;
    'distribution'?: V1Distribution;
    /**
    * ID of the user.
    */
    'userId'?: string;
    /**
    * Date and time of event creation.
    */
    'timestamp'?: Date;
    /**
    * ID of the request.
    */
    'requestId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "distribution",
            "baseName": "distribution",
            "type": "V1Distribution",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineDistributionSet.attributeTypeMap;
    }

    public constructor() {
    }
}

